import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';
import { ActionContext } from 'actions/context';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import CompanyService from 'services/company2';
import Modal from 'components/modal';
import ReceiveService from 'services/receive.ts';
import User from 'services/user2';
import EnumService from 'services/enum2';
import Util from 'lib/util.js';

/* dev
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fsale%2Fdelivery%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2FvendorDelivery%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

function DeliveryList(props) {
  const Config = {
    purchase: {
      apiPath: '/vdeliveryNotice/getPageList',
      countApi: '/vdeliveryNotice/count',
      countApiParams: {
        deliveryTypes: [1, 2, 3, 5]
      },
      orderProperty: 'dn.create_time',
      countTransform: (data, self) => {
        let { 1: a, 5: b, 22: c } = data;
        setCount([undefined, undefined, a, b, c]);
      },
      enumMainKey: 'B02_Dn_Status',
      companyNameKey: 'innerVendorName',
      companyCodeKey: 'innerVendorCode',
      detailLink: '/mp/purchase/vendorDelivery/detail',
      searchBarPlaceholder: '供应商名称/编码、商品名称/编码',
      tabs: ['全部', '签收差异', '待签收', '申请中', '待转入库'],
      arrEnumField: [
        {
          mainKey: 'B02_Dn_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Dn_Logistics_Status',
          subKey: 'logisticsStatus',
          value: 'logisticsStatusName'
        },
        {
          mainKey: 'B02_Dn_Type',
          subKey: 'deliveryType',
          value: 'deliveryTypeName'
        },
        {
          mainKey: 'B02_Send_Verify_Status',
          subKey: 'sendVerifyStatus',
          value: 'sendVerifyStatusName'
        }
      ],
      tabConfig: [
        undefined, //全部
        undefined, //签收差异
        [1], // 待签收
        [5], //申请中
        undefined // 待转入库
      ]
    },
    sale: {
      apiPath: '/deliveryNotice/getPageList',
      countApi: '/deliveryNotice/count',
      orderProperty: 'dn.createTime',
      countTransform: (data, self) => {
        let { 0: a, 1: b, 6: c, 7: d } = data;
        let e = (c || 0) + (d || 0);
        setCount([undefined, a, b, e]);
      },
      enumMainKey: 'B02_Dn_Status',
      companyNameKey: 'innerCustomerName',
      companyCodeKey: 'innerCustomerCode',
      detailLink: '/mp/sale/delivery/detail',
      searchBarPlaceholder: '客户名称/编码、商品名称/编码',
      tabs: ['全部', '未发送', '待签收', '申请待处理'],
      arrEnumField: [
        {
          mainKey: 'B02_Dn_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Dn_Logistics_Status',
          subKey: 'logisticsStatus',
          value: 'logisticsStatusName'
        },
        {
          mainKey: 'B02_Dn_Type',
          subKey: 'deliveryType',
          value: 'deliveryTypeName'
        },
        {
          mainKey: 'B02_Send_Verify_Status',
          subKey: 'sendVerifyStatus',
          value: 'sendVerifyStatusName'
        }
      ],
      tabConfig: [
        undefined, //全部
        [0], //未发送
        [1], //待客户签收
        [6, 7] // 申请待处理
      ]
    }
  };

  const { isRedirct } = props;

  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [showVerifyStatus, setShowVerifyStatus] = useState(true);
  const [redirect, setRedirect] = useState(null);
  const [tabs, setTabs] = useState([]);
  const [dateQueryRangeTypeList, setDateQueryRangeTypeList] = useState([]);
  const [dateQueryRangeType, setDateQueryRangeType] = useState('1');
  const [addressList, setAddressList] = useState([]);
  const [address, setAddress] = useState([]);

  //初始化默认企业
  useEffect(() => {
    self.init();
    EnumService.getList('B2b_OrderDate_QueryRangeType').then(data => {
      if (data.length > 0) {
        setDateQueryRangeTypeList(
          data.filter(item => !['99'].includes(item.subKey))
        );
      }
    });
    if (companyCode) {
      CompanyService.getDeliveryAddressList(companyCode).then(data => {
        setAddressList(data);
      });
    }
  }, [self, companyCode]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount({ dateQueryRangeType: dateQueryRangeType });
  }, [companyCode, dateQueryRangeType, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search(true, 1);
  }, [searchKey, companyCode, currentTab, dateQueryRangeType, address, self]);

  self.beforeSearch = async function () {
    self.searchQueries = {
      status: config.tabConfig[currentTab],
      diffStatus: self.isPurchase && currentTab === 1 ? 1 : undefined,
      dnXkNo: self.searchQueries.dnXkNo,
      logisticsNumber: self.searchQueries.logisticsNumber,
      deliveryTypes: [1, 2, 3, 5],
      dateQueryRangeType: dateQueryRangeType,
      addressCodeList: address
    };
    // 待转入库
    if (currentTab === 4) {
      self.searchQueries.convertStatus = [0, 1];
      self.searchQueries.verifyProcessFlag = 1;
    }
  };

  self.listTransform = async function (arr) {
    if (self.isPurchase) {
      CompanyService.getCompanyParamsByCodes(
        companyCode,
        [
          'Use_platform_recieve_process',
          'Use_recieve_order_down_erp',
          'Use_platform_verify_process',
          'Inspection_by_delivey'
        ],
        false
      ).then(res => {
        let companyParams = {};
        res.forEach(row => {
          companyParams[row.paramCode] =
            row.paramType === 1 ? row.paramValue : row.paramValue === '1';
        });

        let recieveProcess = companyParams['Use_platform_recieve_process'];
        let verifyProcess = companyParams['Use_platform_verify_process'];
        let recieveDownErp = companyParams['Use_recieve_order_down_erp'];
        let inspectDelivey = companyParams['Inspection_by_delivey'];

        // 判断待转入库页签是否显示
        if (!(recieveProcess && recieveDownErp === '2' && verifyProcess)) {
          config.tabs.splice(4, 1);
        }
        setTabs(config.tabs);

        arr.forEach(item => {
          item.companyParams = {};
          /*
           * 未启用平台收货流程，送货单可转检验
           * 启用平台收货流程，下传ERP是入库单，送货单可转检验
           * 启用平台收货流程，下传ERP是收货单、且未开启来料检验，送货单可转检验
           * 启用平台来料检验流程，送货单状态是已完成，屏蔽 新建检验单
           */
          item.canRreateIqcOrder =
            !recieveProcess ||
            (recieveProcess &&
              ((recieveDownErp === '1' && !verifyProcess) ||
                recieveDownErp === '2') &&
              !(item.status === 3 && verifyProcess));
          /*
           * 启用 检验发起必须在货物送达状态,物流状态=已到货,送货单可转检验
           */
          item.inspectDelivey =
            !inspectDelivey || (inspectDelivey && item.logisticsStatus === 2);
        });

        /*
         * 是否展示检验相关字段。启用平台收货流程，下传ERP是收货单、且开启来料检验,不展示检验相关字段
         */
        let showVerify = !(
          recieveProcess &&
          recieveDownErp === '1' &&
          verifyProcess
        );
        setShowVerifyStatus(showVerify);
      });
    } else {
      setTabs(config.tabs);
    }
  };

  //新建来料检验单 sourceOrderType  1来源送货单 2来源收货单 3入库单(api传)
  function createIqcOrder(item) {
    let postbody = {
      sourceXkNo: item.dnXkNo,
      companyCode: item.companyCode,
      sourceOrderType: 1,
      apiPath: '/verify/order/create'
    };
    ReceiveService.createIqcOrder(
      postbody,
      response => {
        let data = response;
        if (!Util.isEmpty(data)) {
          setTimeout(() => {
            if (data.length === 1) {
              setRedirect(
                '/mp/purchase/iqc/detail/' + companyCode + '/' + data[0]
              );
            } else {
              setRedirect('/mp/purchase/iqc/list');
            }
          }, 500);
        }
      },
      dispatch
    );
  }

  // 收货地点改变
  function addressChange(e) {
    setAddress(e.target.value);
  }

  function renderValue() {
    let arr = [];
    address.forEach(code => {
      let name = addressList.filter(item => item.id === code)[0].text;
      arr.push(name);
    });
    return arr.join(', ');
  }

  function dateQueryRangeTypeChange(e) {
    let id = e.target.value;
    setDateQueryRangeType(id);
  }

  function handleDnSearch() {
    self.search(true, 1);
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null && isRedirct !== false) {
    return <Redirect to={redirect} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <Select
              style={{
                width: '50%',
                marginLeft: '5px',
                marginTop: '5px'
              }}
              value={dateQueryRangeType}
              onChange={e => dateQueryRangeTypeChange(e)}
            >
              {dateQueryRangeTypeList.map((item, index) => (
                <MenuItem key={index} value={item.subKey}>
                  {item.subValue}
                </MenuItem>
              ))}
            </Select>

            {props.type === 'purchase' && (
              <div
                style={{
                  marginLeft: '5px',
                  marginTop: '20px'
                }}
              >
                <InputLabel htmlFor="select-multiple">收货地点</InputLabel>
                <Select
                  style={{
                    width: '70%',
                    marginLeft: '5px'
                  }}
                  multiple
                  value={address}
                  renderValue={renderValue}
                  input={<Input id="select-multiple" />}
                  onChange={e => addressChange(e)}
                >
                  {addressList.map(item => (
                    <MenuItem key={item.id} value={item.id}>
                      {/* <Checkbox checked={address.indexOf(item.id) > -1} /> */}
                      <ListItemText primary={item.text} />
                    </MenuItem>
                  ))}
                </Select>
              </div>
            )}

            <TextField
              style={{
                verticalAlign: 'bottom',
                width: '90%',
                marginLeft: '5px',
                paddingRight: '5px',
                marginTop: '0'
              }}
              label="送货通知单号"
              onChange={event => {
                self.searchQueries.dnXkNo = event.target.value;
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    onClick={() => {
                      handleDnSearch();
                    }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              variant="standard"
            />
            <TextField
              style={{
                verticalAlign: 'bottom',
                width: '90%',
                marginLeft: '5px',
                paddingRight: '5px',
                marginTop: '0'
              }}
              label="物流单号"
              onChange={event => {
                self.searchQueries.logisticsNumber = event.target.value;
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    onClick={() => {
                      handleDnSearch();
                    }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              variant="standard"
            />
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {list.map((item, index) => (
                  <div
                    className="content-line line-list-item"
                    key={item.dnXkNo}
                  >
                    <div className="line-list-item-title">
                      <span>{item.dnXkNo}</span>
                      <div className="more">
                        <span
                          className={
                            'u-sign ' +
                            CommonFns.getStatusClass(
                              'B02_Dn_Status',
                              item.status
                            )
                          }
                        >
                          {item.statusName}
                        </span>
                      </div>
                    </div>
                    <ul className="field-list">
                      {self.isPurchase && (
                        <li>
                          <label>供应商</label>
                          <div>
                            {item.innerVendorName}({item.innerVendorCode})
                          </div>
                        </li>
                      )}
                      {!self.isPurchase && (
                        <li>
                          <label>客户</label>
                          <div>
                            {item.customerName}({item.innerCustomerCode})
                          </div>
                        </li>
                      )}
                      <li>
                        <label>送货通知单号</label>
                        <div>
                          <Link
                            to={`${config.detailLink}/${companyCode}/${item.dnXkNo}`}
                          >
                            {item.dnXkNo}
                          </Link>
                        </div>
                      </li>
                      <li>
                        <label>送货日期</label>
                        <div>{formatDate(item.deliveryDate)}</div>
                      </li>
                      <li>
                        <label>送货类型</label>
                        <div>{item.deliveryTypeName}</div>
                      </li>
                      <li>
                        <label>物流状态</label>
                        <div>{item.logisticsStatusName}</div>
                      </li>
                      {item.diffStatus === 1 && (
                        <li>
                          <label>差异状态</label>
                          <div className="red">有差异</div>
                        </li>
                      )}
                      {self.isPurchase && showVerifyStatus && (
                        <li>
                          <label>送检状态</label>
                          <div>
                            <span
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'sendVerify',
                                  item.sendVerifyStatus
                                )
                              }
                            >
                              {item.sendVerifyStatusName}
                            </span>
                          </div>
                        </li>
                      )}
                    </ul>
                    <div className="line-list-item-btns">
                      {/* 送检 */}
                      {self.isPurchase &&
                        User.checkAuth('10080102') &&
                        item.deliveryType !== 2 &&
                        [1, 2, 3].includes(item.status) &&
                        item.multiRelationRoleType !== 2 &&
                        item.canRreateIqcOrder &&
                        [0, 1].includes(item.sendVerifyStatus) &&
                        item.deliveryType !== 4 &&
                        item.inspectDelivey && (
                          <div
                            className="btn"
                            onClick={() => {
                              createIqcOrder(item);
                            }}
                          >
                            送检
                          </div>
                        )}
                    </div>
                  </div>
                ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
            <Modal></Modal>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

DeliveryList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(DeliveryList);
